import { render, staticRenderFns } from "./CellButton.vue?vue&type=template&id=5802754c&scoped=true"
import script from "./CellButton.vue?vue&type=script&lang=js"
export * from "./CellButton.vue?vue&type=script&lang=js"
import style0 from "./CellButton.vue?vue&type=style&index=0&id=5802754c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802754c",
  null
  
)

export default component.exports